(ns lupapalvelu.ui.admin.asiointi-api.common
  (:require [re-frame.core :as rf]))

(def users-for-datatables-query
  [:action/query {:name    :users-for-datatables
                  :params  {:params {:filter-role :asiointi-api}}
                  :success [::users-for-datatables.success]}])

(defn coerce-authz-entry [authz]
  (->> authz
       (map (fn [[org-id roles]]
              [org-id (set (map keyword roles))]))
       (into {})))

(defn- coerce-authz
  "Coerce `:orgAuthz` from vectors of strings to sets of keywords."
  [user]
  (update user :orgAuthz coerce-authz-entry))

(rf/reg-event-fx ::users-for-datatables.success
  (fn [{:keys [db]} [_ resp]]
    (let [users (->> resp :data :rows
                     (map (juxt :_id coerce-authz))
                     (into {}))]
      {:db (assoc-in db [::data :users] users)})))

(def organizations-query
  [:action/query {:name    :asiointi-api-organizations
                  :success [::asiointi-api-organizations.success]}])

(rf/reg-event-fx ::asiointi-api-organizations.success
  (fn [{:keys [db]} [_ {:keys [organizations]}]]
    {:db (assoc-in db [::data :orgs] organizations)}))

(defn init
  [{:keys [db]} [_ visible?]]
  {:pre [(boolean? visible?)]}
  (if visible?
    {:fx [users-for-datatables-query
          organizations-query]}
    {:db (dissoc db ::data)}))

(rf/reg-sub ::data :-> ::data)

(rf/reg-sub ::users
  :<- [::data]
  :-> :users)

(defn db->user
  [db user-id]
  (-> db ::data :users (get user-id)))

(rf/reg-sub ::user
  :<- [::users]
  (fn [users [_ id]]
    (get users id)))

(defn db->orgs
  [db]
  (-> db ::data :orgs))

(rf/reg-sub ::organizations
  :<- [::data]
  :-> :orgs)
